import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  consultarAfiliadoFarmaCard: ["payload"],
  consultarAfiliadoFarmaCardLoading: null,
  consultarAfiliadoFarmaCardSuccess: ["consultarAfiliadoFarmaCardData"],
  consultarAfiliadoFarmaCardFailure: ["consultarAfiliadoFarmaCardError"],

  limpiarDatosAfiliadoFarmaCard: ["payload"],
  limpiarDatosAfiliadoFarmaCardLoading: null,
});

export { Types };

export default Creators;

